<div
    class="back-to-top"
    (click)="scrollToTop()"
    *ngIf="isShow"
    [class.dark-back-to-top]="themeService.isDark()"
>
    <i class='bx bx-chevron-up'></i>
</div>
